import { initialState, InsuredElementState } from './insuredElement.state';
import { ACTION_TYPES } from './insuredElement.actions';

// Reducer
export default (state: InsuredElementState = initialState, action): InsuredElementState => {
  switch (action.type) {
    case ACTION_TYPES.GET_SELLING_POINTS: {
      return {
        ...state,
        sellingPointList: action.payload.sellingPointList
      };
    }
    case ACTION_TYPES.GET_INSURED_GOOD_TYPES: {
      return {
        ...state,
        insuredElementList: action.payload.insuredElementList
      };
    }
    case ACTION_TYPES.UPDATE_INSURED_GOOD: {
      return {
        ...state,
        insuredGood: action.payload
      };
    }
    default:
      return state;
  }
};
